import { render, staticRenderFns } from "./BookNow.vue?vue&type=template&id=54961cfc&scoped=true&"
import script from "./BookNow.vue?vue&type=script&lang=js&"
export * from "./BookNow.vue?vue&type=script&lang=js&"
import style0 from "./BookNow.vue?vue&type=style&index=0&id=54961cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54961cfc",
  null
  
)

export default component.exports